import React from 'react';
import { Close } from '../icons/Close';
import ErrorPopupLayout from '../layouts/ErrorPopupLayout';
const WarningPopup = ({ handleDisplay, closeModal, onCloseWarning, close_warning_btn_close, close_warning_btn_stay, close_warning_text, close_warning_title, deleteFolderContents, globalFolderName, }) => {
    return (React.createElement(React.Fragment, null, handleDisplay && (React.createElement(ErrorPopupLayout, null,
        React.createElement("button", { className: "hg-modal__warning--close", "aria-label": "close", onClick: onCloseWarning },
            React.createElement(Close, null)),
        React.createElement("h2", { className: "hg-modal__warning--title" }, close_warning_title),
        React.createElement("p", null, close_warning_text),
        React.createElement("div", { className: "hg-modal__warning--buttons" },
            React.createElement("button", { className: "btn hg-modal__warning--btn-clear", onClick: onCloseWarning }, close_warning_btn_stay),
            React.createElement("button", { className: "btn btn--full", onClick: () => {
                    closeModal();
                    deleteFolderContents(globalFolderName);
                } }, close_warning_btn_close))))));
};
export default WarningPopup;
